"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawCloud = void 0;
exports.default = Cloud;
var L = require("leaflet");
var createjs = require("@caddigital/easeljs/lib/easeljs");
var Rectangle_1 = require("./Rectangle");
var define = require("./define");
/**
 * TODO: REFACTOR THIS TO OWN FILE
 * convert latlng to point
 * */
var latlngToPoint = function (map, coords, pointCoordinate, zoom) {
    var p = map.project(pointCoordinate, zoom);
    var x = Math.round(p.x - coords.x);
    var y = Math.round(p.y - coords.y);
    // coords to tile space
    return new L.Point(x, y);
};
/**
 * De Castekljau algorithm to approximate the curve
 */
function getCurveBounds(ax, ay, bx, by, cx, cy, dx, dy) {
    var px, py, qx, qy, rx, ry, sx, sy, tx, ty, toqx, toqy, torx, tory, totx, toty;
    var x, y, minx, miny, maxx, maxy;
    minx = miny = Number.POSITIVE_INFINITY;
    maxx = maxy = Number.NEGATIVE_INFINITY;
    var tobx = bx - ax;
    var toby = by - ay; // directions
    var tocx = cx - bx;
    var tocy = cy - by;
    var todx = dx - cx;
    var tody = dy - cy;
    var step = 1 / 40; // precission
    for (var d = 0; d < 1.001; d += step) {
        px = ax + d * tobx;
        py = ay + d * toby;
        qx = bx + d * tocx;
        qy = by + d * tocy;
        rx = cx + d * todx;
        ry = cy + d * tody;
        toqx = qx - px;
        toqy = qy - py;
        torx = rx - qx;
        tory = ry - qy;
        sx = px + d * toqx;
        sy = py + d * toqy;
        tx = qx + d * torx;
        ty = qy + d * tory;
        totx = tx - sx;
        toty = ty - sy;
        x = sx + d * totx;
        y = sy + d * toty;
        minx = Math.min(minx, x);
        miny = Math.min(miny, y);
        maxx = Math.max(maxx, x);
        maxy = Math.max(maxy, y);
    }
    return {
        x: minx,
        y: miny,
        width: maxx - minx,
        height: maxy - miny
    };
}
/**
 * calculate outer bounds of the group of curves
 */
function calculateBounds(x, y, modX, modY) {
    var bounds1 = getCurveBounds(x, y, x - 40 * modX, y + 20 * modY, x - 40 * modX, y + 70 * modY, x + 60 * modX, y + 70 * modY);
    var bounds2 = getCurveBounds(x + 60 * modX, y + 70 * modY, x + 80 * modX, y + 100 * modY, x + 150 * modX, y + 100 * modY, x + 170 * modX, y + 70 * modY);
    var bounds3 = getCurveBounds(x + 170 * modX, y + 70 * modY, x + 250 * modX, y + 70 * modY, x + 250 * modX, y + 40 * modY, x + 220 * modX, y + 20 * modY);
    var bounds4 = getCurveBounds(x + 220 * modX, y + 20 * modY, x + 260 * modX, y - 40 * modY, x + 200 * modX, y - 50 * modY, x + 170 * modX, y - 30 * modY);
    var bounds5 = getCurveBounds(x + 170 * modX, y - 30 * modY, x + 150 * modX, y - 75 * modY, x + 80 * modX, y - 60 * modY, x + 80 * modX, y - 30 * modY);
    var bounds6 = getCurveBounds(x + 80 * modX, y - 30 * modY, x + 40 * modX, y - 75 * modY, x - 40 * modX, y - 60 * modY, x, y);
    // bounds of the graph
    var bMinX = Math.min(bounds1.x, bounds2.x, bounds3.x, bounds4.x, bounds5.x, bounds6.x);
    var bMaxX = Math.max(bounds1.x, bounds1.x + bounds1.width, bounds2.x, bounds2.x + bounds2.width, bounds3.x + bounds3.width, bounds4.x, bounds4.x + bounds4.width, bounds5.x, bounds5.x + bounds5.width, bounds6.x + bounds6.width);
    var bMinY = Math.min(bounds1.y, bounds2.y, bounds3.y, bounds4.y, bounds5.y, bounds6.y);
    var bMaxY = Math.max(bounds1.y, bounds1.y + bounds1.height, bounds2.y, bounds2.y + bounds2.height, bounds3.y, bounds3.y + bounds3.height, bounds4.y, bounds4.y + bounds4.height, bounds5.y, bounds5.y + bounds5.height, bounds6.y, bounds6.y + bounds6.height);
    return {
        x: bMinX,
        y: bMinY,
        width: bMaxX - bMinX,
        height: bMaxY - bMinY
    };
}
/**
 * Static method to draw ínstance into given canvas
 */
var drawCloud = function (graphics, bounds, scale, reverseX, reverseY, color, calculatedBounds) {
    if (reverseX === void 0) { reverseX = false; }
    if (reverseY === void 0) { reverseY = false; }
    if (typeof bounds.min === 'undefined' || typeof bounds.max === 'undefined') {
        return;
    }
    var context = graphics;
    var maxX = !reverseX
        ? Math.max(bounds.min.x, bounds.max.x)
        : Math.min(bounds.min.x, bounds.max.x);
    var minX = !reverseX
        ? Math.min(bounds.min.x, bounds.max.x)
        : Math.max(bounds.min.x, bounds.max.x);
    var maxY = !reverseY
        ? Math.max(bounds.min.y, bounds.max.y)
        : Math.min(bounds.min.y, bounds.max.y);
    var minY = !reverseY
        ? Math.min(bounds.min.y, bounds.max.y)
        : Math.max(bounds.min.y, bounds.max.y);
    var startPoint = new L.Point(minX, minY);
    var endPoint = new L.Point(maxX, maxY);
    var distance = endPoint.distanceTo(startPoint);
    context.clear();
    context
        .beginStroke(createjs.Graphics.getRGB(0, 0, 255, 0.3))
        .setStrokeStyle(1, 'round', 'bevel', 'round')
        .setStrokeDash([5, 5]);
    if (define.DEBUGGING) {
        context.drawRect(bounds.min.x, bounds.min.y, bounds.max.x - bounds.min.x, bounds.max.y - bounds.min.y);
    }
    var y = startPoint.y;
    var x = startPoint.x;
    var modX = Math.max(distance / startPoint.x, distance / startPoint.y);
    var modY = modX;
    var diffX = 0;
    var _bounds = calculateBounds(x, y, modX, modY);
    var bMinX = _bounds.x;
    var bMaxX = _bounds.x + _bounds.width;
    var bMinY = _bounds.y;
    var bMaxY = _bounds.y + _bounds.height;
    diffX = (bMaxX - bMinX) / 2;
    x -= diffX;
    context
        .beginStroke(createjs.Graphics.getRGB(0, 0, 0, 0.3))
        .setStrokeStyle(1, 'round', 'bevel', 'round')
        .setStrokeDash([5, 5]);
    context.rect(bMinX - diffX, bMinY, bMaxX - bMinX, bMaxY - bMinY);
    context
        .beginStroke(color.stroke)
        .setStrokeStyle(define.RECT_LINE_WIDTH * scale, 'round', 'round')
        .setStrokeDash([]);
    context.lineWidth = define.RECT_LINE_WIDTH * scale;
    context.moveTo(x, y);
    context.bezierCurveTo(x - 40 * modX, y + 20 * modY, x - 40 * modX, y + 70 * modY, x + 60 * modX, y + 70 * modY);
    context.bezierCurveTo(x + 80 * modX, y + 100 * modY, x + 150 * modX, y + 100 * modY, x + 170 * modX, y + 70 * modY);
    context.bezierCurveTo(x + 250 * modX, y + 70 * modY, x + 250 * modX, y + 40 * modY, x + 220 * modX, y + 20 * modY);
    context.bezierCurveTo(x + 260 * modX, y - 40 * modY, x + 200 * modX, y - 50 * modY, x + 170 * modX, y - 30 * modY);
    context.bezierCurveTo(x + 150 * modX, y - 75 * modY, x + 80 * modX, y - 60 * modY, x + 80 * modX, y - 30 * modY);
    context.bezierCurveTo(x + 40 * modX, y - 75 * modY, x - 40 * modX, y - 60 * modY, x, y);
};
exports.drawCloud = drawCloud;
function Cloud(map, rect, reverseX, reverseY, color) {
    var _this = this;
    this._reverseX = reverseX;
    this._reverseY = reverseY;
    var origin = map.getPixelOrigin();
    var zoom = map.getZoom();
    var level = zoom;
    var topLeft = latlngToPoint(map, origin, rect.getNorthWest(), zoom);
    var bottomRight = latlngToPoint(map, origin, rect.getSouthEast(), zoom);
    var bounds = new L.Bounds([topLeft, bottomRight]);
    if (typeof bounds.min === 'undefined' || typeof bounds.max === 'undefined') {
        return;
    }
    var maxX = !reverseX
        ? Math.max(bounds.min.x, bounds.max.x)
        : Math.min(bounds.min.x, bounds.max.x);
    var minX = !reverseX
        ? Math.min(bounds.min.x, bounds.max.x)
        : Math.max(bounds.min.x, bounds.max.x);
    var maxY = !reverseY
        ? Math.max(bounds.min.y, bounds.max.y)
        : Math.min(bounds.min.y, bounds.max.y);
    var minY = !reverseY
        ? Math.min(bounds.min.y, bounds.max.y)
        : Math.max(bounds.min.y, bounds.max.y);
    var startPoint = new L.Point(minX, minY);
    var endPoint = new L.Point(maxX, maxY);
    var distance = endPoint.distanceTo(startPoint);
    var x = startPoint.x, y = startPoint.y;
    var modX = Math.max(distance / startPoint.x, distance / startPoint.y);
    var modY = modX;
    var _bounds = calculateBounds(x, y, modX, modY);
    var bMinX = _bounds.x;
    var bMaxX = _bounds.x + _bounds.width;
    var bMinY = _bounds.y;
    var bMaxY = _bounds.y + _bounds.height;
    var diffX = (bMaxX - bMinX) / 2;
    // const diffY = (bMaxY - bMinY) / 2
    var minP = new L.Point(bMinX - diffX, bMinY);
    var maxP = new L.Point(bMaxX - diffX, bMaxY);
    var min = map.unproject(minP.add(origin), level);
    var max = map.unproject(maxP.add(origin), level);
    this.startPoint = startPoint;
    this.modX = modX;
    this.modY = modY;
    var updatedRect = new L.LatLngBounds(min, max);
    Rectangle_1.default.call(this, map, updatedRect, color);
    /**
     * Apply transformation matrix to blitted image
     * using double buffering so that we wont blink
     *
     * 1. pre-transform - clear the path out of canvas, copy canvas state
     * 2. at every frame:
     * 	2.1. save
     * 	2.2 redraw the canvas from saved one
     * 	2.3 transform
     * 	2.4 draw path
     * 	2.5 restore
     * 3. repeat
     *
     * @param {Matrix} matrix
     */
    this.transform = function (matrix, rotation) {
        var m = matrix.matrix;
        var diff = new L.Point(_this.x - m[4], _this.y - m[5]);
        _this._x = _this.x;
        _this._y = _this.y;
        _this.x = m[4];
        _this.y = m[5];
        _this.scaleX = m[0];
        _this.scaleY = m[3];
        _this.skewX = m[1];
        _this.skewY = m[2];
        _this.regX = _this.x;
        _this.regY = _this.y;
        _this.startPoint = _this.startPoint.subtract(diff);
    };
    this._draw = function () {
        var _a = _this, width = _a.width, height = _a.height, modX = _a.modX, modY = _a.modY;
        var x = _this.startPoint.x;
        var y = _this.startPoint.y;
        var color = { fill: _this.fill, stroke: _this.stroke };
        if (_this._selected) {
            color = {
                fill: 'rgba(0, 255, 0, 0.8)',
                stroke: 'rgba(255, 0, 0, 0.8)'
            };
        }
        var context = _this.graphics;
        var bounds = _this._boundingBox;
        context.clear();
        context
            .beginStroke(createjs.Graphics.getRGB(0, 0, 0, 0.3))
            .setStrokeStyle(1, 'round', 'bevel', 'round')
            .setStrokeDash([5, 5]);
        if (define.DEBUGGING) {
            context.rect(bounds.min.x, bounds.min.y, width, height);
        }
        // center
        x -= width / 2;
        context
            .beginStroke(color.stroke)
            .beginFill(color.fill)
            .setStrokeStyle(define.RECT_LINE_WIDTH * _this._scale, 'round', 'round')
            .setStrokeDash([]);
        context.lineWidth = define.RECT_LINE_WIDTH * _this._scale;
        context.moveTo(x, y);
        context.bezierCurveTo(x - 40 * modX, y + 20 * modY, x - 40 * modX, y + 70 * modY, x + 60 * modX, y + 70 * modY);
        context.bezierCurveTo(x + 80 * modX, y + 100 * modY, x + 150 * modX, y + 100 * modY, x + 170 * modX, y + 70 * modY);
        context.bezierCurveTo(x + 250 * modX, y + 70 * modY, x + 250 * modX, y + 40 * modY, x + 220 * modX, y + 20 * modY);
        context.bezierCurveTo(x + 260 * modX, y - 40 * modY, x + 200 * modX, y - 50 * modY, x + 170 * modX, y - 30 * modY);
        context.bezierCurveTo(x + 150 * modX, y - 75 * modY, x + 80 * modX, y - 60 * modY, x + 80 * modX, y - 30 * modY);
        context.bezierCurveTo(x + 40 * modX, y - 75 * modY, x - 40 * modX, y - 60 * modY, x, y);
    };
}
Cloud.prototype = new createjs.Shape();
